export const LAYOUT_CONSTANTS = {
  SIDEBAR_WIDTH: 250,
  SIDEBAR_COLLAPSED_WIDTH: 50,
  MOBILE_BREAKPOINT: 1024,
  DRAWER_WIDTH: 250,
} as const;
